import PropTypes from "prop-types";
import React from "react";
import {first, isArray} from "lodash";
import SelectField from "react-md/lib/SelectFields";
const MSelectField = props => {
  const { input, containerClassName, menuItems, itemLabel, itemValue, ...rest } = props;
  const isInvalidate = rest.meta && rest.meta.touched && rest.meta.error && !!rest.meta.error.length;
  const errorMessage = isInvalidate
    ? (isArray(rest.meta.error) ? first(rest.meta.error) : rest.meta.error)
    : "";

  delete rest.meta;
  delete rest.input;
  delete rest.containerClassName;

  // menuItems could be a string, {label, value} or even only {label}
  const getLabelFromValue = () => {
    if (!menuItems || !Array.isArray(menuItems)) return null;
    // If its a string
    if (menuItems.includes(input.value)) return input.value;
    // If its an object {label, value} or {label}
    return menuItems.reduce((a, c) => {
      if (typeof c === "object") {
        // If its {label, value}
        if (c[itemValue] != null) {
          if (c[itemValue] === input.value) return c[itemLabel];
        }
        // If its {label}
        else if (c[itemLabel] === input.value) return c[itemLabel];
      }
      return a;
    }, null);
  };
  return (<SelectField
        {...rest}
        className={containerClassName}
        value={input.value}
        onChange={input.onChange}
        getActiveLabel={getLabelFromValue}
        data-test={rest.dataTest}
        menuItems={menuItems}
        itemLabel={itemLabel}
        itemValue={itemValue}
        {... isInvalidate && { error: true, errorText: errorMessage }}
  />);
};

MSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  containerClassName: PropTypes.string,
  menuItems: PropTypes.array,
  itemValue: PropTypes.string,
  itemLabel: PropTypes.string
};
export default MSelectField;

